// Style for dashboard module form
const Style = () => ({
  notificationIcon: {
    cursor: 'pointer',
    color: '#C27F49',
    border: '2px',
    borderStyle: 'dashed',
  },
});

export default Style;
